<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <AccountingHelp view="accountingReports" />
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
            </div>
          </div>
        </section>
        <AccountingBookBar :businesses="arr.businesses" :allow-both="false" note="Cada libro tiene sus propios reportes." @change="onBookChange($event)" />
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width:150px;" v-if="report != 'balance'"><label class="filter-label">Desde</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter" style="width:150px;"><label class="filter-label">{{ report == 'balance' ? 'Al' : 'Hasta' }}</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <AccountingAccountsFilter v-show="report == 'ledger'" style="width:240px;" v-model="filters.accounting_accounts_ids" @plan-loaded="accountsCount = $event.length" />
            <b-button variant="outline-dark" size="sm" @click="load()" v-b-tooltip.hover title="Aplicar filtros" aria-label="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-3">
        <b-tabs v-model="tabIndex" content-class="d-none" @input="onTabChange">
          <b-tab v-for="tab in arr.reports" :key="tab.value" :title="tab.text" />
        </b-tabs>

        <div class="p-3">
          <template v-if="data && data.rows.length">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <small class="text-muted">{{ data.business }} - {{ data.condition }} | {{ data.period }}</small>
              <div>
                <b-button size="sm" variant="link" class="list-view-ghost-btn" @click="print()"><AppIcon name="print" class="mr-1" />Imprimir</b-button>
                <export-excel class="d-inline-block" :data="excelRows" :worksheet="data.title" :name="report + '.xls'">
                  <b-button size="sm" variant="link" class="list-view-ghost-btn"><AppIcon name="download" class="mr-1" />Excel</b-button>
                </export-excel>
              </div>
            </div>

            <b-alert show :variant="data.control.ok ? 'success' : 'danger'" class="py-2" v-if="data.control">{{ data.control.message }}</b-alert>
            <small class="text-muted d-block mb-2" v-if="data.note">{{ data.note }}</small>

            <b-table-simple small responsive hover class="app-table mb-0">
              <b-thead>
                <b-tr>
                  <b-th v-for="column in data.columns" :key="column.key" :width="column.width + '%'" :class="{ 'text-right': isAmount(column) }">{{ column.label }}</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(row, index) in pageRows" :key="index" :class="{ 'accounting-report-group': row.bold }">
                  <b-td v-for="column in data.columns" :key="column.key" :class="{ 'text-right': isAmount(column) }"><span :style="cellStyle(column, row)">{{ cell(column, row) }}</span></b-td>
                </b-tr>
              </b-tbody>
              <b-tfoot v-if="data.footer">
                <b-tr class="accounting-report-group">
                  <b-td v-for="column in data.columns" :key="column.key" :class="{ 'text-right': isAmount(column) }">{{ cell(column, data.footer) }}</b-td>
                </b-tr>
              </b-tfoot>
            </b-table-simple>
            <div class="app-table-footer">
              <span class="list-view-toolbar__count">{{ data.rows.length }} filas</span>
              <b-pagination v-if="data.rows.length > perPage" class="mb-0" size="sm" pills="" :total-rows="data.rows.length" :per-page="perPage" v-model="currentPage" />
            </div>
          </template>
          <b-alert show variant="warning" class="mb-0" v-else-if="message">{{ message }}</b-alert>
          <EmptyState v-else-if="!loaded" icon="filter" title="Elegí los filtros" description="Tocá Aplicar filtros para generar el reporte." />
          <EmptyState v-else icon="summarize" title="Sin movimientos" description="No hay asientos aprobados en el período." />
        </div>
      </b-card>

      <Printer v-if="printer.filters" :filters="printer.filters" :reference="printer.reference" :key="printer.key" />

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
  import AccountingHelp from './inc/AccountingHelp'
  import AccountingAccountsFilter from './inc/AccountingAccountsFilter'
  import AccountingBookBar from './inc/AccountingBookBar'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import Printer from '@/components/inc/printer/printer'
  import StorageLocal from '@/handler/storageLocal'
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'

  const AMOUNT_COLUMNS = ['debit', 'credit', 'debit_balance', 'credit_balance', 'balance', 'amount']
  const FILTER_STORAGE_KEY = 'filter_accounting_reports'
  const PER_PAGE = 100
  // Crear un formateador por celda es caro: el Libro Diario tiene miles de importes
  const CURRENCY_FORMAT = Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' })

  export default {
    components: {
      AccountingBookBar,
      AccountingHelp,
      TabHeaderActions,
      ModuleViewHeading,
      Printer,
      AccountingAccountsFilter,
    },
    data: () => {
      return {
        filtersOpen: true,
        access: {
          module_id: Modules.CONTABILIDAD,
          profile_id: Profiles.PERSONAL,
          view_reference: 'accountingReports',
          elements: {}
        },
        tabIndex: 0,
        data: null,
        loaded: false,
        accountsCount: 0,
        loadedFilters: null,
        currentPage: 1,
        perPage: PER_PAGE,
        message: '',
        printer: { key: 0, filters: null, reference: '' },
        filters: {
          business_id: null,
          declared: false,
          date_start: '',
          date_end: moment().format('YYYY-MM-DD'),
          accounting_accounts_ids: null,
        },
        arr: {
          businesses: [],
          reports: [
            { value: 'journal', text: 'Libro Diario' },
            { value: 'ledger', text: 'Mayor' },
            { value: 'trial', text: 'Sumas y Saldos' },
            { value: 'income', text: 'Estado de Resultados' },
            { value: 'balance', text: 'Balance General' },
          ],
        },
      }
    },
    computed: {
      report() {
        return this.arr.reports[this.tabIndex].value
      },
      pageRows() {
        const start = (this.currentPage - 1) * this.perPage
        return this.data.rows.slice(start, start + this.perPage)
      },
      excelRows() {
        const toRow = source => {
          const row = {}
          this.data.columns.forEach(column => {
            row[column.label] = source[column.key] === undefined || source[column.key] === null ? '' : source[column.key]
          })
          return row
        }
        const rows = this.data.rows.map(toRow)
        return this.data.footer ? rows.concat(toRow(this.data.footer)) : rows
      },
    },
    created() {
      Helper.hasAccessView(this.access)
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_accounting_reports', value ? 'true' : 'false')
      },
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_accounting_reports') != 'false'
      this.loadInitial()
    },
    methods: {
      isAmount(column) {
        return AMOUNT_COLUMNS.includes(column.key)
      },
      cell(column, row) {
        const value = row[column.key]
        if(value === undefined || value === null) return ''
        return this.isAmount(column)
          ? CURRENCY_FORMAT.format(value)
          : value
      },
      cellStyle(column, row) {
        return row.level && !this.isAmount(column) && ['account', 'reference'].includes(column.key)
          ? { marginLeft: (row.level * 16) + 'px', display: 'inline-block' }
          : null
      },
      // Prepara los filtros sin generar el reporte: lo pide el usuario con el botón.
      // La empresa y el libro los define el selector de libro, compartido con las demás pantallas.
      loadInitial() {
        serviceAPI.obtenerEmpresas()
        .then(businesses => {
          this.restoreFilterStorage()
          this.arr.businesses = (businesses.data || []).map(business => ({ value: business.id, text: business.name }))
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      // Si ya había un reporte a la vista, se regenera en el libro nuevo
      onBookChange(book) {
        this.filters.business_id = book.business_id
        this.filters.declared = book.declared
        if(this.loaded) this.load()
      },
      // El resultado es de la solapa anterior: no se genera hasta aplicar los filtros
      onTabChange() {
        this.data = null
        this.loaded = false
        this.message = ''
      },
      saveFilterStorage() {
        // Con todas elegidas se guarda null: una cuenta nueva también entra
        const allAccounts = (this.filters.accounting_accounts_ids || []).length == this.accountsCount
        StorageLocal.setValue(FILTER_STORAGE_KEY, JSON.stringify(Object.assign({}, this.filters, allAccounts ? { accounting_accounts_ids: null } : {})))
      },
      restoreFilterStorage() {
        const stored = StorageLocal.getValue(FILTER_STORAGE_KEY)
        if(!stored) return false

        const filters = JSON.parse(stored)
        delete filters.business_id
        delete filters.declared

        this.filters = Object.assign({}, this.filters, filters)
        return true
      },
      // Solo el Mayor filtra por cuenta; con todas elegidas no hace falta mandar la lista
      reportFilters() {
        const filters = Object.assign({}, this.filters)
        const ids = filters.accounting_accounts_ids
        delete filters.accounting_accounts_ids
        if(this.report == 'ledger' && ids && ids.length != this.accountsCount) {
          filters.accounting_accounts_ids = ids.length ? ids : [-1]
        }
        return filters
      },
      load() {
        const loader = this.$loading.show()
        const filters = this.reportFilters()
        this.message = ''
        this.saveFilterStorage()
        serviceAPI.reporteContable(this.report, filters)
        .then(response => {
          loader.hide()
          this.data = response.data
          this.loaded = true
          this.loadedFilters = filters
          this.currentPage = 1
        })
        .catch(error => {
          loader.hide()
          this.data = null
          this.message = error.response && typeof error.response.data == 'string' ? error.response.data : Error.showError(error)
        })
      },
      print() {
        this.printer.reference = 'accounting-' + this.report
        this.printer.key = Math.random()
        this.printer.filters = Object.assign({}, this.loadedFilters)
      },
    }
  }
</script>
<style scoped>
  .accounting-report-group td {
    font-weight: 600;
    background: var(--app-color-surface-subtle);
  }
</style>
